
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 20","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.167 2.62h.166c-.091 0-.166-.081-.166-.18v.18H5.833v-.18c0 .099-.075.18-.166.18h.166v1.62h-1.5v-1.8c0-.794.598-1.44 1.334-1.44h6.666c.736 0 1.334.646 1.334 1.44v1.8h-1.5V2.62zm-10.5 1.62h14.666c.37 0 .667.322.667.72v.72c0 .099-.075.18-.167.18h-1.258l-.515 11.768c-.033.767-.62 1.372-1.33 1.372H4.27c-.712 0-1.297-.603-1.33-1.372L2.425 5.86H1.167C1.075 5.86 1 5.779 1 5.68v-.72c0-.398.298-.72.667-.72zM4.43 17.38h9.138l.504-11.52H3.927l.504 11.52z"}}),_c('path',{attrs:{"d":"M12.167 2.62h.166c-.091 0-.166-.081-.166-.18v.18zm0 0H5.833v-.18c0 .099-.075.18-.166.18h.166v1.62h-1.5v-1.8c0-.794.598-1.44 1.334-1.44h6.666c.736 0 1.334.646 1.334 1.44v1.8h-1.5V2.62zm-10.5 1.62h14.666c.37 0 .667.322.667.72v.72c0 .099-.075.18-.167.18h-1.258l-.515 11.768c-.033.767-.62 1.372-1.33 1.372H4.27c-.712 0-1.297-.603-1.33-1.372L2.425 5.86H1.167C1.075 5.86 1 5.779 1 5.68v-.72c0-.398.298-.72.667-.72zM4.43 17.38h9.138l.504-11.52H3.927l.504 11.52z"}})])
          )
        }
      }
    